import { injectReducer } from '../../store/reducers'
export default (store) => ({
  path : '/orders',
  /*  Async getComponent is only invoked when route matches   */
  getComponents (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Orders = require('./containers/OrdersContainer').default
      const reducer = require('../../store/order').default

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'order', reducer })

      /*  Return getComponent   */
      cb(null, {category:null, main:Orders})

    /* Webpack named bundle   */
    }, 'orders')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Orders/index.js